// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import { deleteVariant, getListVariant } from './variantThunk';

export interface IVariantState {
  isRefreshVariantList: boolean;
}

export const initialState: IVariantState = {
  isRefreshVariantList: false,
};

const variantSlice = createSlice({
  name: 'variant',
  initialState,
  reducers: {
    setRefreshVariantList(state, action) {
      state.isRefreshVariantList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list variant
    builder
      .addCase(getListVariant.pending, (_state) => {})
      .addCase(getListVariant.fulfilled, (_state) => {})
      .addCase(getListVariant.rejected, (_state) => {});

    // DELETE: Delete variant
    builder
      .addCase(deleteVariant.pending, (_state) => {})
      .addCase(deleteVariant.fulfilled, (_state) => {})
      .addCase(deleteVariant.rejected, (_state) => {});
  },
});

// Action
export const variantActions = variantSlice.actions;

// Selectors
export const selectIsRefreshListVariant = (state: RootState) => state.variant.isRefreshVariantList;

// Reducer
const variantReducer = variantSlice.reducer;
export default variantReducer;
